import {
  fetchEkgRecording,
  fetchEkgQT,
  fetchPostEkgQTRequest,
  fetchPostQTValues,
} from 'state/services/recordingApiService';
import * as types from './types';

export const getEkgRecording = recordingId => dispatch => {
  return dispatch({
    type: types.GET_EKG_RECORDING,
    payload: fetchEkgRecording(recordingId),
  }).catch(err => console.log(err));
};

/**
 * Gets Ekg QT intervals and status
 * @param recordingId
 * @returns {function(*): (Promise<void> | ThenPromise<any> | ThenPromise<R|void> | * | Promise<any> | undefined)}
 * NOTE: Data response:
 {
    "qt": {
      "id": "{QT_UUID}",
      "qt": 1.45,
      "rr": 1.21,
      "qtcb": -5.12,
      "qtcf": 145,
      "recordingId": "{recording-id}",
      "deletedAt": null,
    },
    "status": "complete"
 }
 */
export const getEkgQT = (
  recordingId,
  isServiceProviderEnabled,
  isServiceInterpretationFeatureEnabled,
) => dispatch => {
  return dispatch({
    type: types.GET_EKG_QT,
    payload: fetchEkgQT(
      recordingId,
      isServiceProviderEnabled,
      isServiceInterpretationFeatureEnabled,
    ),
  }).catch(err => console.log(err));
};

export const postEkgQTRequest = recordingId => dispatch => {
  return dispatch({
    type: types.POST_QT_REQUEST,
    payload: fetchPostEkgQTRequest(recordingId),
  }).catch(err => console.log(err));
};

export const updateEkgQTStatus = status => {
  return {
    type: types.UPDATE_QT_STATUS,
    payload: status,
  };
};

export const postQTValues = (
  teamId,
  recordingId,
  qtValues,
  isServiceProviderEnabled,
  isServiceInterpretationFeatureEnabled,
  qtConfirm,
) => dispatch => {
  return dispatch({
    type: types.POST_QT_VALUES,
    payload: fetchPostQTValues(
      teamId,
      recordingId,
      qtValues,
      isServiceProviderEnabled,
      isServiceInterpretationFeatureEnabled,
      qtConfirm,
    ),
  }).catch(err => console.log(err));
};



// WEBPACK FOOTER //
// ./src/state/reducers/ekgRecordings/ekgRecordingActions.js